import { requester } from '../utils';

export const getRegion = data => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/region/byCityCode`,
        method: 'POST',
        // cityCode: cityCode,
        withAuth: false,
        data,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log('get region error', err);
        reject(err);
      });
  });
};